import {BaseComponentProcessor} from "@/components/DiagramDesigner/Editor/components/BaseComponentProcessor";
import {StorageNode} from "@/../../common/db/StorageNode"
import {Diagram} from '../../../../../../../../../common/db/Diagram';

export class WidgetProcessor extends BaseComponentProcessor {

    /**
     * Processor constructor
     * @param props
     */
    constructor(...props) {
        super(...props);
    }

    /**
     * Get arguments
     */

    async getArguments() {

        // Get id from type
        const widgetId = this.block.type?.split(":")?.[1];

        // Load widget
        const widget = await Diagram.find(widgetId);

        // Load child diagram
        return await StorageNode.getArguments(widget?.module_id || this.context.module_id, 'diagram-'+widgetId);
    }

}
